/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesh_Test_Not_StartedInputs */



/**
* | output |
* | --- |
* | "Select a network and launch a communication test" |
*
* @param {Mesh_Test_Not_StartedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const mesh_test_not_started = /** @type {((inputs?: Mesh_Test_Not_StartedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesh_Test_Not_StartedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Select a network and launch a communication test")
	return /** @type {LocalizedString} */ ("Sélectionnez un  et lancez un test de communication")
});